import { makeRequest } from 'utils/requestLogger';

export default (id, payload) =>
  makeRequest('post', `/api/roundtables/${id}/add_to_universe`, payload);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/addToUniverse.js